var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.getClassName("parts") },
    [
      _c(
        "div",
        { class: _vm.getClassName("categories") },
        [
          _vm._l(_vm.item.parts_categories, function(category) {
            return _c(
              "button",
              {
                key: category.id,
                class: _vm.getClassName("categories__button"),
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.showModal(category)
                  }
                }
              },
              [
                category.icon !== null
                  ? _c("v-img", {
                      class: _vm.getClassName("categories__icon"),
                      attrs: {
                        src: category.icon,
                        width: _vm.media ? "31px" : "34px",
                        height: _vm.media ? "31px" : "34px"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { class: _vm.getClassName("categories__name") }, [
                  _vm._v(_vm._s(category.name))
                ])
              ],
              1
            )
          }),
          _vm._v(" "),
          this.noPartsVueFlg
            ? _c(
                "button",
                {
                  class: _vm.getNoPartsActive("categories__button"),
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.showModalForNoParts()
                    }
                  }
                },
                [
                  _c("v-img", {
                    class: _vm.getClassName("categories__icon"),
                    attrs: {
                      src: "../../images/icon_noselection.jpg",
                      width: _vm.media ? "31px" : "34px",
                      height: _vm.media ? "31px" : "34px"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { class: _vm.getClassName("categories__name") }, [
                    _vm._v("パーツなし")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("items"),
      _vm._v(" "),
      _vm.visible
        ? _c("div", { class: _vm.getClassName("modal") }, [
            _c("div", {
              class: _vm.getClassName("modal__overlay"),
              on: { click: _vm.hideModal }
            }),
            _vm._v(" "),
            _c("div", { class: _vm.getClassName("modal__wrapper") }, [
              _c(
                "button",
                {
                  staticClass: "modal__close--upper",
                  attrs: { type: "button" },
                  on: { click: _vm.hideModal }
                },
                [_c("span", { staticClass: "modal__cross--white" })]
              ),
              _vm._v(" "),
              _c("div", { class: _vm.getClassName("modal__content") }, [
                _c("div", { class: _vm.getClassName("modal__scroll") }, [
                  _c("div", { class: _vm.getClassName("modal__title") }, [
                    _vm._v(_vm._s(_vm.category.name))
                  ]),
                  _vm._v(" "),
                  _vm.showComment(_vm.category)
                    ? _c("p", { class: _vm.getClassName("modal__comment") }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.item.category.name.replace(" ", "")) +
                            "1" +
                            _vm._s(_vm.item.unit) +
                            "につきパーツが8本必要になります\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.getClassName("modal__options") },
                    [
                      _vm._l(_vm.category.items, function(item) {
                        return _vm._l(item.options, function(option) {
                          return _c(
                            "label",
                            {
                              key: _vm.uuid + "-" + option.id,
                              class: _vm.getClassNameActive(
                                "modal__option",
                                _vm.setValue(item, option),
                                _vm.parts
                              ),
                              attrs: { for: _vm.uuid + "-" + option.id }
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: option.color.thumbnail,
                                  alt: option.color.name,
                                  contain: "",
                                  "aspect-ratio": 1
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { class: _vm.getClassName("modal__name") },
                                [
                                  _vm._v(
                                    _vm._s(item.name) +
                                      " " +
                                      _vm._s(option.color.name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              item.sizes.length > 1
                                ? _c(
                                    "div",
                                    { class: _vm.getClassName("modal__size") },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(option.size.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { class: _vm.getClassName("modal__price") },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.getPriceFormat(option.price)) +
                                      "円（税込）\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.parts,
                                    expression: "parts"
                                  },
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                attrs: {
                                  id: _vm.uuid + "-" + option.id,
                                  type: "checkbox"
                                },
                                domProps: {
                                  value: _vm.setValue(item, option),
                                  checked: Array.isArray(_vm.parts)
                                    ? _vm._i(
                                        _vm.parts,
                                        _vm.setValue(item, option)
                                      ) > -1
                                    : _vm.parts
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.parts,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = _vm.setValue(item, option),
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.parts = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.parts = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.parts = $$c
                                    }
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: _vm.getClassName("modal__add"),
                    attrs: { type: "button" },
                    on: { click: _vm.add }
                  },
                  [_vm._v("\n          チェックした商品を追加する\n        ")]
                ),
                _vm._v(" "),
                !_vm.media
                  ? _c(
                      "button",
                      {
                        staticClass: "modal__close",
                        attrs: { type: "button" },
                        on: { click: _vm.hideModal }
                      },
                      [
                        _c("span", { staticClass: "modal__cross" }),
                        _vm._v("\n          閉じる\n        ")
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.visibleForNoParts
        ? _c("div", { class: _vm.getClassName("modal") }, [
            _c("div", {
              class: _vm.getClassName("modal__overlay"),
              on: { click: _vm.hideModalForNoParts }
            }),
            _vm._v(" "),
            _c("div", { class: _vm.getClassName("modal__wrapper") }, [
              _c(
                "button",
                {
                  staticClass: "modal__close--upper",
                  attrs: { type: "button" },
                  on: { click: _vm.hideModalForNoParts }
                },
                [_c("span", { staticClass: "modal__cross--white" })]
              ),
              _vm._v(" "),
              _c("div", { class: _vm.getClassName("modal__content") }, [
                _c("div", { class: _vm.getClassName("modal__scroll") }, [
                  _c("div", { class: _vm.getClassName("modal__title") }, [
                    _vm._v("パーツなし")
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { class: _vm.getClassName("modal__comment--noparts") },
                    [
                      _vm._v(
                        "\n            こちらの商品には取り付けパーツは付属しておりません。"
                      ),
                      _c("br"),
                      _vm._v("パーツがないと吊ることができません。"),
                      _c("br"),
                      _vm._v(
                        "※オプションパーツをご希望の方は別途購入が必要です。\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: _vm.getClassName("modal__add"),
                    attrs: { type: "button" },
                    on: { click: _vm.selectNoParts }
                  },
                  [_vm._v("\n          了承して選択する\n        ")]
                ),
                _vm._v(" "),
                !_vm.media
                  ? _c(
                      "button",
                      {
                        staticClass: "modal__close",
                        attrs: { type: "button" },
                        on: { click: _vm.hideModalForNoParts }
                      },
                      [
                        _c("span", { staticClass: "modal__cross" }),
                        _vm._v("\n          閉じる\n        ")
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }